var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{ref:"image",staticClass:"image",class:{ loading: _vm.loading, loaded: _vm.loaded, animate: _vm.animate },attrs:{"src":_vm.lazySrc,"srcset":_vm.lazySrcSet,"alt":_vm.alt,"width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }